export default {
  linkList: [
    [
      {
        title: "ผลิตภัณฑ์เทรด",
        list: [
          {
            label: "ฟอเร็กซ์",
            link: "/tradingproduct?index=0",
          },
          {
            label: "สินค้าโภคภัณฑ์",
            link: "/tradingproduct?index=1",
          },
          {
            label: "ดัชนี",
            link: "/tradingproduct?index=2",
          },
          {
            label: "หุ้นสหรัฐฯ",
            link: "/tradingproduct?index=3",
          },
          {
            label: "ETF",
            link: "/tradingproduct?index=4",
          },
        ],
      },
      {
        title: "เครื่องมือเทรด",
        list: [
          {
            label: "ดาวน์โหลด MT4",
            link: "/MT4",
          },
          {
            label: "ดาวน์โหลด MT5",
            link: "/MT5",
          },
          {
            label: "EA Forex & Indicator",
            link: "/tools",
          },
          {
            label: "PAMM",
            link: "/PAMM",
          },
          {
            label: "การวิเคราะห์ตลาด",
            link: "/market-analysis",
          },
        ],
      },
    ],
    [
      {
        title: "บัญชีและเงื่อนไข",
        list: [
          {
            label: "บัญชีเทรด",
            link: "/TradingAccount",
          },
          {
            label: "เลเวอเรจ & มาร์จิ้น",
            link: "/leverage-margin",
          },
          {
            label: "ฝาก & ถอน",
            link: "/funding",
          },
          {
            label: "เงินปันผล",
            link: "/dividend",
          },
          {
            label: "บริการสถาบัน",
            link: "/service",
          },
          {
            label: "เชื่อมต่อสภาพคล่อง",
            link: "/technology",
          },
        ],
      },
    ],
    
    [
      {
        title: "เกี่ยวกับ EBC",
        list: [
          {
            label: "WHY EBC",
            link: "/about-us",
          },
          {
            label: "เอกสารทางกฎหมาย",
            link: "/LegalDocumen",
          },
          {
            label: "ความรับผิดชอบต่อสังคม",
            link: "/ESG",
          },
          {
            label: "ข่าวสาร EBC",
            link: "/LearningCenter?tabId=0",
          },
          {
            label: "คำถามที่พบบ่อย",
            link: "https://support.ebchelp.com/hc/th",
          },
          {
            label: "ตรวจสอบเว็บไซต์",
            link: "/official-verification",
          },
        ],
      },
      {
        title: "พันธมิตร",
        list: [
          {
            label: "สโมสรบาร์เซโลนา ",
            link: "/FCB",
          },
          {
            label: "มหาวิทยาลัย Oxford",
            link: "/partners/oxford",
          },
          {
            label: "โปรแกรมพันธมิตร",
            link: "/affiliate-programmes",
          },
        ],
      },
    ],
    [
        {
          title: "กิจกรรมยอดนิยมของ EBC",
          list: [
            {
              label: "แข่งเทรด EBC Million Dollar Trading Challenge",
              link: "/million-dollar-challenge-2",
            },
            {
              label: "โปรแกรมครีเอทีฟ",
              link: "/activityList/creator-incentives",
            },
            {
              label: "โปรแกรมมาสเตอร์",
              link: "/pay",
            },
           
            
            {
              label: "กิจกรรมเพิ่มเติม",
              link: "/activity",
            },
          ],
        },
    ],
  ],
  context: `
     <p>
        <span class="page-footer-intro-blod">
          EBC Financial Group มีกลุ่มองค์กรเครือข่ายต่างๆ ได้แก่:<br />
        </span>
        EBC Financial Group (SVG) LLC ได้รับอนุญาตจาก St.Vincent และ The
        Grenadines Financial Services Authority (SVGFSA) หมายเลขจดทะเบียนบริษัท
        353 LLC 2020 ,ที่อยู่สำนักงานที่จดทะเบียน Euro House, Richmond Hill
        Road, Kingstown, VC0100, St. Vincent and the Grenadines.
        
      </p>
      <p>
        <span class="page-footer-intro-blod">หน่วยงานที่เกี่ยวข้อง:<br /></span>
        EBC FINANCIAL GROUP (UK) LTD ได้รับอนุญาตและควบคุมโดย Financial Conduct
        Authority (FCA) หมายเลขควบคุม: 927552 ,เว็บไซต์:
        <a target="_blank" href="https://www.ebcfin.co.uk" rel="nofollow"
          >www.ebcfin.co.uk</a
        >
        <br />
        EBC FINANCIAL GROUP (CAYMAN) LTD ได้รับอนุญาตและควบคุมโดย Cayman Islands
        Monetary Authority (CIMA) หมายเลขควบคุม: 2038223 ,เว็บไซต์:
        <a target="_blank" href="https://www.ebcgroup.ky" rel="nofollow"
          >www.ebcgroup.ky</a
        >
        <br />
        EBC Financial (MU) Limited
        ได้รับอนุญาตและควบคุมโดยคณะกรรมการบริการทางการเงินแห่งมอริเชียส
        (Financial Services Commission, Mauritius) หมายเลขใบอนุญาต: GB24203273
        โดยมีที่อยู่จดทะเบียนที่ชั้น 3, Standard Chartered Tower, Cybercity,
        Ebene, 72201, สาธารณรัฐมอริเชียส
        เว็บไซต์ของหน่วยงานที่ระบุมีการดูแลแยกต่างหาก
        <br />
        EBC Financial Group (Comoros) Limited ได้รับอนุญาตจาก The Autonomous
        Island of Anjouan, Union of Comoros Offshore Finance Authority
        หมายเลขใบอนุญาต: L 15637/EFGC โดยมีที่อยู่จดทะเบียนที่ Hamchako,
        Mutsamudu, Autonomous Island of Anjouan, Union of Comoros
        <br />
        EBC Financial Group (Australia) Pty Ltd (ACN: 619 073 237)
        ได้รับอนุญาตและควบคุมโดย Australian Securities and Investments
        Commission (ASIC) หมายเลข: 500991 โดย EBC Financial Group (Australia)
        Pty Ltd เป็นองค์กรที่เกี่ยวข้องกับ EBC Financial Group (SVG) LLC
        ทั้งสององค์กรมีการบริหารจัดการแยกต่างหาก
        ผลิตภัณฑ์และบริการทางการเงินที่นำเสนอในเว็บไซต์นี้ไม่ได้ให้บริการโดยองค์กรในออสเตรเลียและไม่สามารถเรียกร้องความรับผิดชอบจากองค์กรในออสเตรเลียได้
        <br />
        EBC Group (Cyprus) Ltd
        ให้บริการการชำระเงินแก่หน่วยงานที่ได้รับใบอนุญาตและอยู่ภายใต้การควบคุมภายในองค์กรของ
        EBC Financial Group โดยจดทะเบียนภายใต้กฎหมายบริษัทของสาธารณรัฐไซปรัส
        หมายเลข: HE 449205 ,ที่อยู่สำนักงานที่จดทะเบียน 101 Gladstonos,
        Agathangelou Business Centre, 3032 Limassol, Cyprus
      </p>
      <p>
        <span class="page-footer-intro-blod"> ที่อยู่บริษัท:</span>
        The Leadenhall Building, 122 Leadenhall Street, London, United Kingdom
        EC3V 4AB ,อีเมล: cs@ebc.com ,หมายเลขโทรศัพท์: +44 20 3376 9662
      </p>
     
      <p>
        <span class="page-footer-intro-blod">ข้อจำกัดภูมิภาค:</span>
        EBC ไม่ได้ให้บริการแก่ผู้ใช้งานที่อยู่ในเขตอำนาจศาลบางแห่ง ได้แก่
        อัฟกานิสถาน, เบลารุส, เมียนมาร์, แคนาดา, สาธารณรัฐแอฟริกากลาง, คองโก,
        คิวบา, สาธารณรัฐประชาธิปไตยคองโก, เอริเทรีย, ไนจีเรีย, อิหร่าน, อิรัก,
        เลบานอน, ลิเบีย, มาเลเซีย, มาลี, เกาหลีเหนือ (สาธารณรัฐประชาชนเกาหลี),
        รัสเซีย, โซมาเลีย, ซูดาน, ซูดานใต้, ซีเรีย, ยูเครน
        (รวมถึงภูมิภาคไครเมีย, โดเนตสก์, และลูฮันสค์), สหรัฐอเมริกา, เวเนซุเอลา,
        และเยเมน
        <br />
        ภาษาสเปนที่เผยแพร่บนเว็บไซต์นี้ใช้ได้เฉพาะกับประเทศในละตินอเมริกา
        และไม่สามารถใช้ได้กับสหภาพยุโรปและสเปน
        <br />
        ภาษาโปรตุเกสที่เผยแพร่บนเว็บไซต์นี้ใช้ได้เฉพาะในแอฟริกาเท่านั้น
        ไม่สามารถใช้ได้กับสหภาพยุโรป โปรตุเกส และบราซิล
      </p>
      <p>
        <span class="page-footer-intro-blod"
          >การเปิดเผยการปฏิบัติตามข้อกำหนด:</span
        >เว็บไซต์บริษัทสามารถเข้าถึงได้ทั่วโลกและไม่ได้เจาะจงไปที่องค์กรใดองค์กรหนึ่ง
        สิทธิ์และภาระผูกพันของคุณถูกกำหนดโดยองค์กรและเขตอำนาจศาลที่คุณเลือก
        กฎหมายและข้อบังคับท้องถิ่นอาจห้ามหรือจำกัดไม่ให้คุณเข้าไปดาวน์โหลด
        แจกจ่าย เผยแพร่ แบ่งปัน หรือใช้เอกสาร ข้อมูลใด ๆ ที่เผยแพร่ในเว็บไซต์นี้
      </p>
      <p>
        <span class="page-footer-intro-blod">คำเตือนความเสี่ยง:</span
        >การซื้อขายสัญญาส่วนต่าง (CFD) เป็นเครื่องมือทางการเงินที่ซับซ้อน
        และมีความเสี่ยงสูง เนื่องจากการใช้เลเวอเรจ
        การซื้อขายด้วยมาร์จิ้นมีความเสี่ยงสูงและอาจไม่เหมาะสำหรับนักลงทุนทุกท่าน
        ก่อนตัดสินใจทำการซื้อขายฟอเร็กซ์หรือ CFD
        คุณควรพิจารณาอย่างรอบคอบเกี่ยวกับวัตถุประสงค์ในการซื้อขาย
        ระดับประสบการณ์ และความสามารถในการรับความเสี่ยงของคุณ
        อาจมีความเป็นไปได้ที่คุณอาจสูญเสียเงินทุนบางส่วนหรือทั้งหมด
        เราขอแนะนำให้คุณขอคำแนะนำจากที่ปรึกษาอิสระและตรวจสอบให้แน่ใจว่าคุณเข้าใจความเสี่ยงที่เกี่ยวข้องอย่างครบถ้วนก่อนตัดสินใจลงทุน
        กรุณาอ่านคำชี้แจงเกี่ยวกับความเสี่ยงที่เกี่ยวข้องอย่างละเอียดก่อนทำการซื้อขาย
      </p>
  `,
};
